import {getArticlePage, getArticlesByPage} from './articles';

export const apiArticles = {
  getArticlePage,
  getArticlesByPage,
};
